import bootstrap from 'bootstrap';
import Readmore from './classes/readmore';
import SaitApp from './classes/sait-app';
import Utility from "./classes/utility";

const LazyLoad = require('vanilla-lazyload');

// global window defines
declare global {
    interface Window {
        lazyload: any;
        bootstrap: any;
        saitApp: SaitApp;
     }
}

const globalInit = function () {
    // global js functions
    let lazyload = new LazyLoad();
    lazyload.update();
    window.lazyload = lazyload;
    window.bootstrap = bootstrap;

    // cheeky hack to patch underlines for new ion-icons font
    const ioniconsOnPage = document.querySelectorAll('a ion-icon');
    if (ioniconsOnPage && ioniconsOnPage.length > 0) {
        ioniconsOnPage.forEach(function(icon) { icon.parentElement.classList.add("text-decoration-none") });
    }

    window.saitApp = new SaitApp();

    // Fix for modals backdrop overtop of modal
    document.addEventListener('DOMContentLoaded', () => {
        document.querySelectorAll('.modal').forEach(modal => document.body.appendChild(modal));
    });

    // TODO: support more than one readmore per page
    let readMore = new Readmore('readmore-container');
}
Utility.cookieYesFix();
globalInit();